import { render } from "./PersonWishlistPage.vue?vue&type=template&id=313c1869&scoped=true"
import script from "./PersonWishlistPage.vue?vue&type=script&lang=js"
export * from "./PersonWishlistPage.vue?vue&type=script&lang=js"

import "./PersonWishlistPage.vue?vue&type=style&index=0&id=313c1869&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-313c1869"

export default script